import { doBasicCheck, ValidationResult } from '../../validator/shared';
import { Params } from './types';
import paramsList from './params-list';

export default (params: Params): ValidationResult => {
    if (!doBasicCheck(params, paramsList).isValid) {
        return doBasicCheck(params, paramsList);
    }

    return {
        isValid: true,
    };
};
